import { MAX_DEADLINE_SLACK_MINUTES } from '@chukua/common';
import { Form, InputNumber } from 'antd';

/**
 * A trip's projected arrival against the job's deadline. One rule is one step: for "warn at 60 minutes, escalate at 30, critical at 0" the
 * office adds three rules of this type, each with its own severity, and the tighter step should be the more severe.
 */
export function DeadlineFields() {
  return (
    <Form.Item
      name="slackMinutes"
      label="Fires when the margin is down to (minutes)"
      extra="Margin is the deadline minus the projected arrival, rest stops included. 0 means projected to be late. For several steps, add a rule per step: when the margin shrinks past a tighter, more severe step, its alert replaces the milder one."
      rules={[
        {
          required: true,
          type: 'number',
          min: 0,
          max: MAX_DEADLINE_SLACK_MINUTES,
          message: `Enter 0 to ${MAX_DEADLINE_SLACK_MINUTES} minutes`,
        },
      ]}
    >
      <InputNumber min={0} max={MAX_DEADLINE_SLACK_MINUTES} precision={0} className="w-32" />
    </Form.Item>
  );
}
